import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Provider } from 'react-redux';
import createStore from './src/redux/createStore';
import { theme2022 } from '@nordiskafintech/web';

import { Shadows } from '@mui/material/styles/shadows';
import UrqlProvider from './UrqlProvider';

const theme = createTheme({
  ...theme2022,
  shadows: Array(25).fill('none') as Shadows,
});

// eslint-disable-next-line react/display-name,react/prop-types
export default ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  //
  // IMPORTANT: render the EXACT same tree on server and client. Gatsby/React 18
  // hydrate the server HTML with `hydrateRoot`; if the first client render does
  // not match the SSR output, Gatsby falls back to `createRoot().render()`,
  // which appends a second copy of the app next to the SSR markup (visible
  // duplication, no production warning). We therefore do NOT branch on
  // `typeof window` and do NOT use redux-persist's <PersistGate>, which renders
  // `null` on the first paint and guarantees a mismatch. The persistor still
  // rehydrates the store asynchronously below.
  const { store } = createStore();

  return (
    <Provider store={store}>
      <UrqlProvider>
        <ThemeProvider theme={theme}>{element}</ThemeProvider>
      </UrqlProvider>
    </Provider>
  );
};
